import UserBookingAvailabilityDTO from '@src/adapters/dto/user/UserBookingAvailabilityDTO';
import useApi, { ApiOptions } from '../base/useApi';

export interface Params {
  dateFrom: Date;
  dateTo: Date;
  productionId: string | undefined;
  jobId: string | undefined;
}

export interface Result {
  availabilities: UserBookingAvailabilityDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/user/booking_availabilities/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: true,
  useGCKey: true,
  manualErrorHandling: true,
};

export const useGetBookingAvailabilitiesLazy = (params?: Params) => {
  return useApi<Params, Result>(options, params);
};

export default useGetBookingAvailabilitiesLazy;
